import { useSetAlert, type AlertConfig } from '@cluber/carabiner'

const defaultAlertConfig: Omit<AlertConfig, 'status'> = {
  location: 'upper-right',
  closeAfter: 7000,
  dismissible: false,
}

type NotificationType = Pick<AlertConfig, 'status'> & Partial<Omit<AlertConfig, 'status'>>

export function notify(config: NotificationType) {
  const { addAlert } = useSetAlert()
  addAlert({
    ...defaultAlertConfig,
    ...config,
  })
}

export function resetNotifications() {
  const { resetAlerts } = useSetAlert()
  resetAlerts()
}
